import { ChangeEvent, useState } from "react";
import { useAdmin } from "../../../context/admin";
import Modal from "../../common/Modal";
import { Payment } from "../../../types/common.types";
import GeneralInput from "../../common/GeneralInput";
import Dropdown from "../../common/Dropdown";
import FileInput from "../../common/FileInput";
import { AiFillCloseCircle } from "react-icons/ai";
import jsonToFormData from "../../../utils/jsonToFormData";
import AdminService from "../../../services/admin.service";

// used for traspax
export default function EditPayment() {
    const { editPaymentData, setEditPaymentData } = useAdmin()
    const [newData, setNewData] = useState<Payment>(editPaymentData as Payment)
    function onChange(e: ChangeEvent<HTMLInputElement>) {
        const name = e.target.name
        let value: string | number
        if (e.target.type === 'number') {
            value = Number(e.target.value)
        } else {
            value = e.target.value
        }
        setNewData(prevData => ({...prevData, [name]: value}))
    }

    function onChangeFiles(newFile: File | undefined, name: keyof Payment) {
        console.log(newFile)
        setNewData(prevData => ({...prevData, [name]: newFile}))
    }

    async function onSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault()
        try {
            const formattedData = {
                amount: (!newData.amount || newData.amount?.toString() === 'null') ? 0 : newData.amount,
                remarks: newData.remarks,
                payment_method: newData.payment_method,
                pic: newData.pic,
                amount_tickets: (!newData.amount_tickets || newData.amount_tickets?.toString() === 'null') ? 0 : newData.amount_tickets,
            }
            const formData = jsonToFormData(formattedData)
            await AdminService.editPayment(editPaymentData!.id, formData)
            window.location.reload()
        } catch (error) {
            console.log(error)
        }
    }
    return (
        <Modal onSubmit={onSubmit}>
            <h1>Edit Payment</h1>
            <GeneralInput
            label="Amount"
            placeholder="10.000"
            value={newData.amount?.toString() || ''}
            onChange={onChange}
            type="number"
            name="amount"
            />
            <GeneralInput
            label="Amount tickets"
            placeholder="10"
            value={newData.amount_tickets?.toString() || ''}
            onChange={onChange}
            type="number"
            name="amount_tickets"
            style={{margin: '20px 0'}}
            />
            <GeneralInput
            label="Remarks"
            value={newData.remarks}
            onChange={onChange}
            name="remarks"
            style={{margin: '20px 0'}}
            />
            <div className="payment">
                <h2>Payment method</h2>
                <h3>{editPaymentData!.payment_method}</h3>
                <Dropdown
                title="Payment method"
                options={['transfer', 'cash']}
                onSelect={(newValue: string) => setNewData(prevData => ({...prevData, payment_method: newValue}))}
                />
            </div>
            <FileInput
            style={{margin: '10px 0'}}
            value={editPaymentData!.pic}
            deleteFile={() => onChangeFiles(undefined, 'pic')}
            accept=".png, .jpg, .jpeg, .heic"
            onChange={(newFile: File) => onChangeFiles(newFile, 'pic')}
            />
            <div className="actions">
                <button type="submit" className="save">Save</button>
            </div>
            <div className="close">
                <AiFillCloseCircle onClick={() => setEditPaymentData(undefined)}/>
            </div>
        </Modal>
    )
}